import React, { useRef } from 'react';
import classnames from 'classnames';

import { ModelCloseIcon } from '@whelk/assets/src/web/common-icons';

const MD_WIDTH_MAP = {
  sm: 'md:w-[375px]',
  md: 'md:w-[550px]',
  lg: 'md:w-[750px]',
};

function ResponsiveModal({
  open,
  onClickMask,
  children,
  onClose,
  title,
  size = 'md',
  className,
  closeOnEscape,
  closeBtn = true,
}: {
  open: boolean;
  onClickMask?: () => void;
  onClose?: () => void;
  children: React.ReactNode;
  title?: string;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  closeOnEscape?: boolean;
  closeBtn?: boolean;
}) {
  if (!open) return null;

  const clickInner = useRef(false);

  const handleKeyDown = (e: any) => {
    if (e.key === 'Escape' && closeOnEscape) {
      onClose?.();
    }
  };

  const handleClickMask = () => {
    if (clickInner.current) {
      clickInner.current = false;
      return;
    }
    onClickMask?.();
  };

  const handleMouseDownInner = () => {
    clickInner.current = true;
  };

  const handleMouseUpInner = () => {
    clickInner.current = false;
  };

  return (
    <section className='fixed bottom-0 left-0 right-0 top-0 z-[1100]' onKeyDown={handleKeyDown}>
      <div
        className='bg-col_mask00 flex min-h-full w-full flex-col items-center justify-end md:justify-center md:p-8 md:pb-10 '
        onClick={handleClickMask}
      >
        <div
          onClick={(e) => e.stopPropagation()}
          className='flex h-full w-full flex-col items-end md:h-auto md:w-auto md:items-center'
        >
          <div
            className={classnames(
              'text-col_text02 bg-col_bg09 relative w-full overflow-hidden rounded-t-[20px] text-[16px] md:rounded-[20px]',
              MD_WIDTH_MAP[size],
              className ? className : 'p-4 md:p-6',
            )}
            onMouseDown={handleMouseDownInner}
            onMouseUp={handleMouseUpInner}
          >
            <div className='flex items-center'>
              {title && (
                <span className='text-col_text00 pb-4 text-[16px] font-medium leading-[28px]'>
                  {title}
                </span>
              )}
              {onClose && (
                <span
                  className={`md:hover:bg-col_text05 text-col_text02 md:text-col_text03 absolute right-4 top-4 z-50 flex h-6 w-6 cursor-pointer items-center justify-center rounded md:right-6 md:top-6 md:h-[30px] md:w-[30px] ${
                    !closeBtn ? 'hidden md:block' : ''
                  }`}
                  onClick={handleClickMask}
                >
                  <ModelCloseIcon />
                </span>
              )}
            </div>
            {!closeBtn && (
              <div
                className='slider-box mx-auto w-8 rounded-sm pb-2 pt-[10px] md:hidden'
                onTouchStart={handleClickMask}
              >
                <div className='bg-col_text03 h-[5px] w-8 rounded-[4px] opacity-50' />
              </div>
            )}

            {children}
          </div>
        </div>
      </div>
    </section>
  );
}

export default ResponsiveModal;
